<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('E')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="exportFile(form)"
          >
            {{ '导出' }}
            <i class="el-icon-download" />
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/factory/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'factory-qualityUReportRecord',
        searchForm: {},
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpPendingGoodsQualityUserPageListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
      }
    },
  },
}
</script>
